export default "__VITE_ASSET__7cf1e07e__"